import React from 'react';
import { ModernChatSystem } from './_components/ModernChatSystem';
import { useSelector } from 'react-redux';
import Header from '../../components/template/Header';
import BreadCrumb from '../../components/template/BreadCrumb';

export default function Chat() {
  const data = useSelector((state) => state.auth);

  const currentUserId = data?.user?._id;

  return (
    <div className='pace-done'>
      <div>
        <Header />
        {/* <BreadCrumb
          title={'Chat'}
          mainLinkTitle='Dashboard'
          mainLinkUrl='/dashboard'
          activeLink={'xchat'}
        /> */}

        <div className='chat-page'>
          <ModernChatSystem currentUserId={currentUserId} />
        </div>
      </div>
    </div>
  );
}




